import { Options } from '@angular-slider/ngx-slider';
import { Component, OnInit } from '@angular/core';
import { SearchFilterService } from '../../services/search-filter.service';
import { Store } from '@ngrx/store';
import {
  ActiveFilterCollection,
  Colors,
  VolumeRange,
  DiameterRange,
  FilterInterface,
  Shape,
  Material,
  PriceRange,
  ProductCategories,
  ProductSections,
  Style,
  Brands,
} from '../../interfaces/filter.interface';
import { first } from 'rxjs/operators';
import {
  CollectFilters,
  ResetFilters,
  SelectMaterial,
  SelectStyle,
  SetVolumeRange,
  SetDiameterRange,
  SetPriceRange,
  SelectBrand,
} from '../../store/actions/filter.actions';
import { Router } from '@angular/router';
import { DataService } from '../../../../core/services/data.service';
import { CartService } from '../../../cart/services/cart.service';
import { Subscription } from 'rxjs';
import { CollectionsService } from '../../../collections/service/collections.service';
import i18next from 'i18next';
import { defaultFilter } from 'src/modules/search-filter/store/reducers/filter.reducer';

@Component({
  selector: 'app-search-filter-overlay',
  templateUrl: './search-filter-overlay.component.html',
  styleUrls: ['./search-filter-overlay.component.scss'],
})
export class SearchFilterOverlayComponent implements OnInit {
  priceActive = false;
  filterable = false;
  dataLoaded = this.collectionsService.dataLoaded;
  private subscriptions: Subscription = new Subscription();
  filteredProductsLength = 0;
  selectedProductCategories: ProductCategories = {};
  selectedProductSections: ProductSections = {};
  selectedShape: Shape = {};
  selectedColors: Colors = {};
  productsSectionsFilterList!: any;
  productCategoriesFilterList!: any;
  colorsFilterList!: any;
  shapeFilterList!: any;
  selectedMaterial!: string;
  materials: Material = {};
  materialOptions: any;
  selectedStyle!: string;
  styles: Style = {};
  styleOptions: any;
  selectedBrand!: string;
  brands: Brands = {};
  brandOptions: any;
  lang!: string;
  highestPrice!: number;
  lowestPrice!: number;
  highestVolume!: number;
  lowestVolume!: number;
  lowestDiameter!: number;
  highestDiameter!: number;

  priceRange: PriceRange = {};

  volumeRange: VolumeRange = {};

  diameterRange: DiameterRange = {};

  optionsPriceRange: Options = {};

  optionsVolumeRange: Options = {};

  optionsDiameterRange: Options = {};

  constructor(
    private searchFilterService: SearchFilterService,
    private dataService: DataService,
    private collectionsService: CollectionsService,
    private cartService: CartService,
    private store: Store<{ filter: FilterInterface }>,
    private router: Router
  ) {
    const collectionDataSub =
      this.collectionsService.loadDataObservable$.subscribe(() => {
        this.serveData();
      });
    this.subscriptions.add(collectionDataSub);
  }

  ngOnInit(): void {
    this.checkFilterable();
    if (this.dataLoaded) {
      this.serveData();
    }
  }

  serveData(): void {
    this.highestPrice = Math.trunc(this.collectionsService.getHighestPrice());
    this.lowestPrice = Math.trunc(this.collectionsService.getLowestPrice());
    this.highestVolume = Math.trunc(this.collectionsService.getHighestVolume());
    this.lowestVolume = Math.trunc(
      this.collectionsService.getLowestVolume() + 1
    );
    this.lowestDiameter = Math.trunc(
      this.collectionsService.getLowestDiameter() + 1
    );
    this.highestDiameter = Math.trunc(
      this.collectionsService.getHighestDiameter()
    );

    this.priceRange = {
      startPrice: this.lowestPrice,
      endPrice: this.highestPrice,
    };

    this.volumeRange = {
      startVolume: this.lowestVolume,
      endVolume: this.highestVolume,
    };

    this.diameterRange = {
      startDiameter: this.lowestDiameter,
      endDiameter: this.highestDiameter,
    };

    this.optionsPriceRange = {
      floor: this.lowestPrice,
      ceil: this.highestPrice,
    };

    this.optionsVolumeRange = {
      floor: this.lowestVolume,
      ceil: this.highestVolume,
    };

    this.optionsDiameterRange = {
      floor: this.lowestDiameter,
      ceil: this.highestDiameter,
    };

    this.lang = i18next.language;
    const priceActiveSub = this.cartService.priceActive$.subscribe((value) => {
      this.priceActive = value;
    });
    this.subscriptions.add(priceActiveSub);

    this.store
      .select('filter')
      .pipe(first())
      .subscribe((data) => {
        if (data.activeFilterCollection.brand) {
          this.selectedBrand = data.activeFilterCollection.brand;
        }
        if (data.activeFilterCollection.material) {
          this.selectedMaterial = data.activeFilterCollection.material;
        }
        if (data.activeFilterCollection.style) {
          this.selectedStyle = data.activeFilterCollection.style;
        }
        if (data.tags.priceRange.endPrice) {
          this.priceRange = { ...data.tags.priceRange };
        }
        if (data.tags.volumeRange.endVolume) {
          this.volumeRange = { ...data.tags.volumeRange };
        }
        if (data.tags.diameterRange.endDiameter) {
          this.diameterRange = { ...data.tags.diameterRange };
        }
      });
    this.store.select('filter').subscribe((data) => {
      //7console.log('initial filter setup');
      // this.materials = {...data.tags.materials};
      // this.styles = {...data.tags.styles};
      // this.brands = {...data.tags.brands};
      this.selectedProductSections = { ...data.tags.productSections };
      // delete this.selectedProductSections.type;
      this.selectedProductCategories = { ...data.tags.productCategories };
      this.selectedShape = { ...data.tags.shape };
      this.selectedColors = { ...data.tags.colors };
      //console.log(Object.values(this.selectedProductSections));
      //console.log(Object.values(this.selectedProductSections).includes(true));
      this.checkFilterable();
    });

    this.productsSectionsFilterList =
      this.dataService.filterList.articleFilters.category_type.de;
    this.colorsFilterList = this.dataService.filterList.articleFilters.color.de;
    this.shapeFilterList = this.dataService.filterList.articleFilters.shape.de;
    this.productCategoriesFilterList =
      this.dataService.filterList.articleFilters.article_type.de;
    this.materialOptions =
      this.dataService.filterList.articleFilters.material[this.lang];
    this.styleOptions =
      this.dataService.filterList.articleFilters.style[this.lang];
    this.brandOptions =
      this.dataService.filterList.articleFilters.brand[this.lang];
  }

  checkFilterable(): void {
    //console.log('Check Filterable');
    //console.log(this.materials);
    this.filterable =
      Object.values(this.selectedProductSections).includes(true) ||
      Object.values(this.selectedProductCategories).includes(true) ||
      Object.values(this.selectedShape).includes(true) ||
      Object.values(this.selectedColors).includes(true) ||
      this.isEmpty(this.selectedMaterial) ||
      this.isEmpty(this.selectedStyle) ||
      this.isEmpty(this.selectedBrand) ||
      this.diameterRange.endDiameter !== this.highestDiameter ||
      this.diameterRange.startDiameter !== this.lowestDiameter ||
      this.priceRange.endPrice !== this.highestPrice ||
      this.priceRange.startPrice !== this.lowestPrice ||
      this.volumeRange.startVolume !== this.lowestVolume ||
      this.volumeRange.endVolume !== this.highestVolume;
  }

  isEmpty(str: string): boolean {
    return !(!str || str.length === 0);
  }

  handleFilterOverlay(): void {
    this.searchFilterService.filterOpen = !this.searchFilterService.filterOpen;
    window.dispatchEvent(new Event('resize'));
  }

  selectMaterial(material: string): void {
    Object.keys(this.materials).forEach((key) => {
      this.materials[key] = false;
    });
    if (material !== null) {
      this.materials[material] = !this.materials[material];
    }
    this.checkFilterable();
  }

  selectStyle(style: string): void {
    Object.keys(this.styles).forEach((key) => {
      this.styles[key] = false;
    });
    if (style !== null) {
      this.styles[style] = !this.styles[style];
    }
    this.checkFilterable();
  }

  selectBrand(brand: string): void {
    Object.keys(this.brands).forEach((key) => {
      this.brands[key] = false;
    });
    if (brand !== null) {
      this.brands[brand] = !this.brands[brand];
    }
    this.checkFilterable();
  }

  priceRangeStart(startPrice: number): void {
    this.priceRange.startPrice = startPrice;
    this.checkFilterable();
  }

  priceRangeEnd(endPrice: number): void {
    this.priceRange.endPrice = endPrice;
    this.checkFilterable();
  }

  volumeRangeStart(startVolume: number): void {
    this.volumeRange.startVolume = startVolume;
    this.checkFilterable();
  }

  volumeRangeEnd(endVolume: number): void {
    this.volumeRange.endVolume = endVolume;
    this.checkFilterable();
  }

  diameterRangeStart(startDiameter: number): void {
    this.diameterRange.startDiameter = startDiameter;
    this.checkFilterable();
  }

  diameterRangeEnd(endDiameter: number): void {
    this.diameterRange.endDiameter = endDiameter;
    this.checkFilterable();
  }

  collectFilters(): ActiveFilterCollection {
    const activeFilterCollection: ActiveFilterCollection = {
      colors: [],
      shape: [],
      material: '',
      style: '',
      brand: '',
      sections: [],
      categories: [],
    };
    //console.log('collect Filter');

    for (const colorKey in this.selectedColors) {
      if (this.selectedColors[colorKey] && colorKey !== 'type') {
        activeFilterCollection.colors.push(
          this.getKeyByValue(colorKey, this.colorsFilterList)
        );
      }
    }

    for (const shapeKey in this.selectedShape) {
      if (this.selectedShape[shapeKey] && shapeKey !== 'type') {
        activeFilterCollection.shape.push(
          this.getKeyByValue(shapeKey, this.shapeFilterList)
        );
      }
    }
    for (const sectionsKey in this.selectedProductSections) {
      if (this.selectedProductSections[sectionsKey] && sectionsKey !== 'type') {
        activeFilterCollection.sections.push(
          this.getKeyByValue(sectionsKey, this.productsSectionsFilterList)
        );
      }
    }
    for (const categoriesKey in this.selectedProductCategories) {
      if (
        this.selectedProductCategories[categoriesKey] &&
        categoriesKey !== 'type'
      ) {
        activeFilterCollection.categories.push(
          this.getKeyByValue(categoriesKey, this.productCategoriesFilterList)
        );
      }
    }
    if (this.selectedMaterial) {
      activeFilterCollection.material = this.selectedMaterial;
    }
    if (this.selectedStyle) {
      activeFilterCollection.style = this.selectedStyle;
    }
    if (this.selectedBrand) {
      activeFilterCollection.brand = this.selectedBrand;
    }

    //console.log(activeFilterCollection);
    this.store.dispatch(CollectFilters(activeFilterCollection));
    this.searchFilterService.activateFilter$.next(true);
    return activeFilterCollection;
  }

  applyFilters(): void {
    // deep clone
    const filter = JSON.parse(JSON.stringify(defaultFilter));
    if (
      this.diameterRange.startDiameter !== undefined &&
      this.diameterRange.endDiameter !== undefined
    ) {
      this.store.dispatch(SetDiameterRange(this.diameterRange));
      filter.tags.diameterRange = this.diameterRange;
    }

    if (
      this.volumeRange.startVolume !== undefined &&
      this.volumeRange.endVolume !== undefined
    ) {
      this.store.dispatch(SetVolumeRange(this.volumeRange));
      filter.tags.volumeRange = this.volumeRange;
    }

    if (
      this.priceRange.startPrice !== undefined &&
      this.priceRange.endPrice !== undefined
    ) {
      this.store.dispatch(SetPriceRange(this.priceRange));
      filter.tags.priceRange = this.priceRange;
    }

    this.store.dispatch(SelectStyle(this.styles));
    this.store.dispatch(SelectMaterial(this.materials));
    this.store.dispatch(SelectBrand(this.brands));
    // this.store.dispatch(SelectProductCategories(this.selectedProductCategories));
    // this.store.dispatch(SelectProductSections(this.selectedProductSections));
    // this.store.dispatch(SelectShapes(this.selectedShape));
    // this.store.dispatch(SelectColors(this.selectedColors));
    this.searchFilterService.searchTerm$.next('');
    const activeFilterCollection = this.collectFilters();
    filter.activeFilterCollection = activeFilterCollection;
    filter.tags.styles = this.styles;
    filter.tags.materials = this.materials;
    filter.tags.brands = this.brands;
    this.handleFilterOverlay();
    this.router.navigate(['/search'], {
      queryParams: {
        s: JSON.stringify(filter),
      },
      queryParamsHandling: 'merge',
    });
  }

  resetFilters(): void {
    this.filterable = false;
    //console.log('reset');
    this.searchFilterService.resetFilters$.next(true);
    this.selectedMaterial = '';
    this.store.dispatch(SelectMaterial(this.materials));

    this.selectedStyle = '';
    this.store.dispatch(SelectStyle(this.styles));

    this.selectedBrand = '';
    this.store.dispatch(SelectBrand(this.brands));
    this.priceRange = {
      startPrice: this.lowestPrice,
      endPrice: this.highestPrice,
    };

    this.volumeRange = {
      startVolume: this.lowestVolume,
      endVolume: this.highestVolume,
    };

    this.diameterRange = {
      startDiameter: this.lowestDiameter,
      endDiameter: this.highestDiameter,
    };
    this.selectedColors = {};
    this.selectedProductCategories = {};
    this.selectedProductSections = {};
    this.selectedShape = {};
    this.store.dispatch(ResetFilters());
    // this.collectFilters();
    this.searchFilterService.resetFilters$.next(false);
  }

  getKeyByValue(value: string, filterList: any): string {
    const indexOfF = Object.values(filterList).indexOf(value);
    return Object.keys(filterList)[indexOfF];
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
